/**
 * Numeric knobs for terra-draw that differ between mouse and touch input.
 * On touch, tap precision is poor: enlarge the pointer hit-radius and the
 * closing/vertex point sizes so tapping the closing point (to finish a polygon)
 * and grabbing a vertex (to adjust) are reliable with a fingertip.
 *
 * Non-touch MUST return the exact values the desktop cutter used before this
 * helper existed (closingPointWidth 6, no pointerDistance, no select styling),
 * so the desktop experience is unchanged.
 */
export interface TerraDrawTouchTuning {
  /** Max px distance a pointer can be from a coordinate and still "hit" it.
   *  Omitted (undefined) on non-touch → terra-draw uses its own default. */
  pointerDistance?: number
  /** Polygon closing-point marker width (the tap target that finishes a polygon). */
  closingPointWidth: number
  /** Select-mode vertex marker width. Omitted on non-touch → no style override. */
  selectionPointWidth?: number
}

export function terraDrawTouchTuning(touch?: boolean): TerraDrawTouchTuning {
  if (touch) {
    return { pointerDistance: 30, closingPointWidth: 14, selectionPointWidth: 14 }
  }
  return { closingPointWidth: 6 }
}
